import React from "react";

import { observer } from "mobx-react";
import Link from "next/link";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledTitle = styled.div`
  width: 140px;
  background: ${({ theme }) => theme.primaryBackgroundColor};
  padding: 0.3em;
  font-size: 0.9rem;
  font-weight: 600;
  color: ${({ theme }) => theme.primaryColor};
  position: absolute;
  min-height: 2rem;
  top: -1rem;

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.secondaryColor};
    background: ${({ theme }) => theme.secondaryBackgroundColor};
  }
`;

const StyledVacancy = styled.a`
  display: block;
  color: inherit;
  text-decoration: none;
  position: relative;
  margin: 1rem;
  background: ${({ theme }) => theme.primaryBackgroundColor};

  .vacancy-text-section {
    padding: 1rem;
    padding-top: 3rem;
    transition: background-color 0.5s ease;
    gap: 3rem;
  }

  &:hover {
    cursor: pointer;

    .vacancy-text-section {
      background-color: ${({ theme }) => theme.primaryBackgroundColor};
    }

    .company-name {
      color: ${({ theme }) => theme.secondaryColor};
    }

    .vacancy-title {
      color: ${({ theme }) => theme.negativeTextColor};
    }
  }
`;

function JobCardWithTitle(props) {
  const { vacancy, showLocation } = props;

  let endDate = vacancy?.endDate;

  if (endDate) {
    const dateObject = new Date(endDate);

    // Checking if the date is valid
    if (!Number.isNaN(dateObject.getTime())) {
      endDate = dateObject.toLocaleDateString();
    } else {
      endDate = undefined;
    }
  }

  let secondaryText = (
    <p className="company-name mt-auto fw-bold">
      {endDate || "Open until filled"}
    </p>
  );

  if (showLocation && vacancy?.location?.city) {
    secondaryText = (
      <p className="company-name mt-auto fw-bold">{vacancy?.location?.city}</p>
    );
  }

  return (
    <Link href={`/job/${vacancy.id}`} passHref legacyBehavior>
      <StyledVacancy className="text-center d-flex flex-column align-items-center justify-content-center job-card-with-title">
        <StyledTitle className="job-card-title">{vacancy.category}</StyledTitle>
        <div className="vacancy-text-section w-100 d-flex flex-column px-1">
          <h3 className="vacancy-title mt-2 mb-4 fw-bold text-uppercase">
            {vacancy?.jobTitle}
          </h3>
          {secondaryText}
        </div>
      </StyledVacancy>
    </Link>
  );
}

export default observer(JobCardWithTitle);

JobCardWithTitle.propTypes = {
  showLocation: PropTypes.bool,
  vacancy: PropTypes.shape({
    category: PropTypes.string,
    company: PropTypes.shape({
      name: PropTypes.string,
    }),
    hoursType: PropTypes.string,
    id: PropTypes.number,
    jobTitle: PropTypes.string,
    location: PropTypes.shape({
      city: PropTypes.string,
    }),
    remuneration: PropTypes.shape({
      description: PropTypes.string,
    }),
  }),
};

JobCardWithTitle.defaultProps = {
  showLocation: false,
  vacancy: {},
};
